import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import services from "./slices/servicesSlice";
import bookings from "./slices/bookingsSlice";
import vehicle from "./slices/vehicleSlice";
import driver from "./slices/driverSlice";
import chat from "./slices/chatSlice";
import ads from "./slices/adsSlice";
import disputes from "./slices/disputesSlice";
import trips from "./slices/tripsSlice";
import announcements from "./slices/announcementsSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    services,
    bookings,
    vehicle,
    driver,
    chat,
    ads,
    disputes,
    trips,
    announcements,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
